import { useState } from "react";
import MapPreview from '../MapPreview';
import { 
    MdClose
} from 'react-icons/md';


const EditZone = (props) => {

    const [zoneName, setName] = useState(props.edit||props.delete ? props.location.ZONE : '');
    const [address, setAddress] = useState(props.edit||props.delete ? props.location.ADDRESS : '');
    const [location, setLocation] = useState({x: '14.598914950', y: '-90.50600514652838' });
    
    const save = () => {
        if(zoneName.trim().length == 0){
            return window.alert('Ingresa una zona o nombre valido.');
        }

        if(address.trim().length == 0){
            return window.alert('Ingresa una direccion valida.');
        }

        if(props.edit){
            const index = props.locations.indexOf(props.location);
            const locations = props.locations.slice();            
            const currentLocation = { ADDRESS: address, LOCATIONX: location.x, LOCATIONY: location.y, ZONE: zoneName };
                  locations[index] = currentLocation;
            props.setRestaurant((prev) => ({...prev, location: locations}));
            setTimeout(() => props.setLocation(currentLocation), 10);
            props.close();

            props.export({location: locations});

        }else if(props.delete){
            const index = props.locations.indexOf(props.location);
            const locations = props.locations.filter((element) => element != props.location);
            
            props.setRestaurant((prev) => ({...prev, location: locations}));
            props.close();

            props.export({location: locations}, index);
        }else{
            const locations = props.locations.slice();
            const currentLocation = { ADDRESS: address, LOCATIONX: location.x, LOCATIONY: location.y, ZONE: zoneName };
            locations.push(currentLocation);
            props.setRestaurant((prev) => ({...prev, location: locations}));
            setTimeout(() => props.setLocation(currentLocation), 10);
            props.close();
            props.export({location: locations});
        }
    }

    return (
        <>
            <div>
                Nombre o Zona: <input type='text' value={zoneName} onChange={(e) => setName(e.target.value)} disabled={props.delete}/>
            </div>
            <div className="mt-1">
                Direccion: <input type='text' value={address} onChange={(e) => setAddress(e.target.value)} disabled={props.delete}/>
            </div>
            <div className="mt-1">
                <MapPreview lat={location.x} lng={location.y} setLocation={setLocation} edit delete={props.delete}/>
            </div>
            <div className="mt-2">
                <button className={props.delete? 'm-auto btn btn-cancel':'m-auto btn btn-accept'} onClick={save}>{props.delete?'Borrar':'Guardar'}</button>
            </div>
        </>
    );
}

export default EditZone;